// @flow

import { connect } from 'react-redux';
import { useQuery, useMutation } from '@apollo/react-hooks';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { UniversalNavProvider } from '@zapier/universal-layout';

import { Account } from '@zapier/shared-entities';

const mapStateToProps = state => {
  return {
    currentAccountId: Account.selectors.all.currentAccountId(state),
    currentUrl: RouterSelectors.currentUrl(state) || '',
    useMutation,
    useQuery,
  };
};

export default connect(mapStateToProps)(UniversalNavProvider);
